/**
 * Assign buffer + offset/length fields for internal access.
 *
 * @param {Object} self - The object to assign fields on
 * @param {Buffer} buffer - The buffer
 * @param {Number} [offset=0] - The offset
 * @param {Number} [length=buffer.length] - The length
 */
module.exports.assignInternals = function(self, buffer, offset, length) {
    self.$buffer = buffer;
    self.$offset = offset || 0;
    self.$length = length === undefined ? buffer.length : length;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/data/util.js
// module id = 321
// module chunks = 1